import { render, staticRenderFns } from "./_3.vue?vue&type=template&id=8b386dac&scoped=true&"
import script from "./_3.vue?vue&type=script&lang=js&"
export * from "./_3.vue?vue&type=script&lang=js&"
import style0 from "./_3.vue?vue&type=style&index=0&id=8b386dac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b386dac",
  null
  
)

export default component.exports